export const LOAD_ACCOUNT_SNAPSHOT = 'event-guestside-site/LOAD_ACCOUNT_SNAPSHOT';
export const LOAD_EVENT_SNAPSHOT = 'event-guestside-site/LOAD_EVENT_SNAPSHOT';
export const LOAD_WEBSITE_CONTENT = 'event-guestside-site/LOAD_WEBSITE_SNAPSHOT';
export const LOAD_REGISTRATION_PROCESS_CONTENT = 'event-guestside-site/LOAD_REGISTRATION_PROCESS_SNAPSHOT';
export const LOAD_VISIBLE_PRODUCTS = 'event-guestside-site/LOAD_VISIBLE_PRODUCTS';
export const LOAD_REG_CART_VISIBLE_PRODUCTS = 'event-guestside-site/LOAD_REG_CART_VISIBLE_PRODUCTS';
export const RESET_VISIBLE_PRODUCTS = 'event-guestside-site/RESET_VISIBLE_PRODUCTS';
export const LOAD_VISIBLE_SESSION_PRODUCTS = 'event-guestside-site/LOAD_VISIBLE_SESSION_PRODUCTS';
export const LOAD_VISIBLE_PRODUCTS_BY_REG_TYPE = 'event-guestside-site/LOAD_VISIBLE_PRODUCTS_BY_REG_TYPE';
